export {default} from 'views/ContractDetailsReport/ContractDetailsReport'


// WEBPACK FOOTER //
// ./src/views/Reports/ContractDetailsReport.jsx